import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import CloudOff from "@mui/icons-material/CloudOff";
import Icon from "@mui/material/Icon";
// limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import { defaultImage } from "@limitless/images";

//Limitess imports
import { withi18n } from "../hocs/i18n";
const imageFileW = 200;
const otherFileW = 120;
class AttachmentBody extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isImage: true,
      isValidURL: props.attachment.valid === false ? false : true
    };
    this.checkUrlIsImage = this.checkUrlIsImage.bind(this);
  }
  checkUrlIsImage(url, callback) {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      callback(true);
    };
    image.onerror = () => {
      callback(false);
    };
  }
  render() {
    const {
      attachment,
      classes,
      t,
      backgroundStyle,
      isCustomer,
      textStyling
    } = this.props;
    const {
      isValidURL
    } = this.state;
    this.checkUrlIsImage(attachment.url, isImage => {
      if (isImage) {
        this.setState({
          isImage: true
        });
      } else {
        this.setState({
          isImage: false
        });
      }
    });
    const isImageRemoved = attachment.scannedStatus && attachment.url.includes("unscanned");
    return /*#__PURE__*/React.createElement("div", {
      id: "attchmentBody",
      style: isCustomer && this.state.isImage && !isImageRemoved ? {
        left: `calc(100% - ${(isValidURL ? imageFileW : otherFileW) + 10}px)`
      } : {},
      className: `${isValidURL && attachment.scannedStatus !== null && !isImageRemoved ? classes.cursorPointer : ""} ${classes.listItem} ${this.state.isImage && !isImageRemoved ? backgroundStyle : classes.defaultBackgroundStyle} ${isValidURL ? classes.image : classes.file}`,
      onClick: () => {
        if (isValidURL && attachment.scannedStatus && !isImageRemoved) {
          window.open(attachment.url, "_blank");
        }
      }
    }, !attachment.scannedStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `${classes.imageOverlay}`
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "div",
      className: classes.proccessImageText,
      variant: isCustomer ? "caption" : "body2"
    }, t("The image has been sent and is now being processed/reviewed"))), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundImage: `url('${attachment.url}')`
      },
      className: classes.imageContainer
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, isValidURL ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundImage: this.state.isImage && !isImageRemoved ? `url('${attachment.url}')` : `url('${defaultImage}')`
      },
      className: this.state.isImage && !isImageRemoved ? classes.imageContainer : classes.defaultImageContainer
    }), isImageRemoved && /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, t("Image removed due to content filter"))) : /*#__PURE__*/React.createElement("div", {
      className: classes.noFile
    }, /*#__PURE__*/React.createElement(Icon, {
      className: `${classes.iconContainer} ${textStyling}`
    }, /*#__PURE__*/React.createElement(CloudOff, {
      classes: {
        root: textStyling
      },
      className: classes.icon
    })), /*#__PURE__*/React.createElement(Typography, {
      classes: {
        root: textStyling
      },
      component: "div"
    }, t("File not found")))));
  }
}
const styles = theme => {
  var _theme$palette$backgr;
  return {
    listItem: {
      display: "flex",
      flex: "1",
      position: "relative",
      borderRadius: 12,
      flexDirection: "column",
      overflow: "hidden",
      margin: "0 0 8px 8px"
    },
    imageContainer: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: 120
    },
    defaultImageContainer: {
      height: 98,
      width: 120,
      margin: "auto",
      backgroundRepeat: "no-repeat"
    },
    defaultBackgroundStyle: {
      margin: "auto"
    },
    fileContainer: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: 20
    },
    file: {
      width: `${otherFileW}px`
    },
    image: {
      width: `${imageFileW}px`
    },
    cursorPointer: {
      cursor: "pointer"
    },
    imageOverlay: {
      display: "flex",
      position: "absolute",
      flexDirection: "column",
      height: "100%",
      justifyContent: "space-evenly",
      alignItems: "center",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "rgba(0,0,0,.6)",
      transition: "opacity 0.2s ease-out"
    },
    iconContainer: {
      width: 30,
      height: 30
    },
    icon: {
      fontSize: 30
    },
    noFile: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      marginTop: 20,
      padding: "5px 0 20px 0"
    },
    proccessImageText: {
      color: (_theme$palette$backgr = theme.palette.background.white) !== null && _theme$palette$backgr !== void 0 ? _theme$palette$backgr : theme.palette.primary.contrastText,
      paddingLeft: 7,
      paddingRight: 7
    }
  };
};
export default withStyles(styles)(withi18n(AttachmentBody));
AttachmentBody.propTypes = {
  attachment: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  backgroundStyle: PropTypes.string,
  isCustomer: PropTypes.bool,
  textStyling: PropTypes.string
};
AttachmentBody.default = {
  isCustomer: false
};